import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=03bdf31e&scoped=true&lang=pug&"
import script from "./Id.vue?vue&type=script&lang=js&"
export * from "./Id.vue?vue&type=script&lang=js&"
import style0 from "./Id.vue?vue&type=style&index=0&id=03bdf31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdf31e",
  null
  
)

/* custom blocks */
import block0 from "./Id.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports